module.exports = __webpack_public_path__ + "img/r.2b6a7a26.jpg";